var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82ZM21.1152 35.4963C21.1152 27.1382 28.1844 17.1162 42.2038 17.1162C53.4693 17.1162 60.8839 25.245 60.8839 33.9708C60.8839 45.5129 54.4487 54.136 44.9628 54.136C41.7772 54.136 38.7807 52.4189 37.7541 50.4685C37.7541 50.4685 36.0414 57.2479 35.6786 58.557C35.0529 60.8255 33.8284 63.0926 32.7088 64.8598L29.2258 63.5915C29.1428 61.537 29.2112 59.0706 29.7395 56.8351C30.3068 54.4466 33.536 40.8027 33.536 40.8027C33.536 40.8027 32.5936 38.924 32.5936 36.1475C32.5936 31.7872 35.128 28.531 38.2843 28.531C40.9683 28.531 42.2649 30.5411 42.2649 32.9483C42.2649 34.6632 41.5658 36.9201 40.8296 39.2965C40.4109 40.6482 39.9802 42.0386 39.6593 43.39C38.9201 46.5111 41.2283 49.0566 44.3161 49.0566C49.9067 49.0566 53.6725 41.8966 53.6725 33.4133C53.6725 26.9647 49.3163 22.1378 41.394 22.1378C32.4433 22.1378 26.8675 28.794 26.8675 36.2286C26.8675 38.7921 27.6253 40.5995 28.8125 41.9993C29.3584 42.6423 29.4342 42.901 29.2366 43.6394C29.1632 43.9202 29.0403 44.4064 28.9203 44.8812C28.8091 45.3214 28.7003 45.7518 28.6356 46.0003C28.4392 46.7455 27.8333 47.0122 27.1579 46.737C23.0352 45.0588 21.1152 40.5569 21.1152 35.4963Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPinterest);
export default __webpack_public_path__ + "static/media/logoPinterest.9165ec2d7d64ec939db85a800fabbf7b.svg";
export { ForwardRef as ReactComponent };